import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { AppContext } from 'context';
import { DEFAULT_COUNTRY_CODE, DEFAULT_LOCALE } from 'modules/App/constants';
import { langCode as langCodeSelector, signUpCountryCode as signUpCountryCodeSelector } from 'modules/App/selectors';
import { accountCountryCode as accountCountryCodeSelector } from 'modules/Account/selectors';
export const fallbackPatterns = 4;
export const useFileName = (url, fileName, fallbackIndex, setPatternIndex)=>{
    const { staticStorageUrl } = useContext(AppContext);
    const locale = useSelector(langCodeSelector);
    const signUpCountryCode = useSelector(signUpCountryCodeSelector);
    const countryCode = useSelector(accountCountryCodeSelector);
    const code = countryCode || signUpCountryCode || DEFAULT_COUNTRY_CODE;
    // Language fallbacks for terms and policy documents.
    // If the system cannot find the appropriate file, it attempts to load the next file according to the
    // following pattern to display documents in the available/default language.
    const langFallbackSuffixes = [
        `${fileName}_${code.toUpperCase()}_${locale.toUpperCase()}`,
        `${fileName}_${code.toUpperCase()}_${DEFAULT_LOCALE.toUpperCase()}`,
        `global/${fileName}_${locale.toUpperCase()}`,
        `global/${fileName}_${DEFAULT_LOCALE.toUpperCase()}`
    ];
    if (langFallbackSuffixes[fallbackIndex - 1] && langFallbackSuffixes[fallbackIndex - 1] === langFallbackSuffixes[fallbackIndex]) {
        if (setPatternIndex && fallbackIndex !== fallbackIndex + 1) {
            setPatternIndex(fallbackIndex + 1);
        }
        return null;
    }
    return `${staticStorageUrl}/${url}/${langFallbackSuffixes[fallbackIndex]}.pdf`;
};
